import React from 'react';

import GetSlides from '@src/api/GetSlides';
import { SlideType } from '@src/enums';
import { generateSlide } from '@src/factories';
import useAxiosErrorHandler from '@src/hooks/useAxiosErrorHandler';
import useAxiosRequestConfig from '@src/hooks/useAxiosRequestConfig';
import useIsMounted from '@src/hooks/useIsMounted';
import { Slide } from '@src/types';

const useSlides = (
  id: SlideType = SlideType.TopSlides
): { data: Slide[]; loading: boolean } => {
  const axiosRequestConfig = useAxiosRequestConfig();
  const axiosErrorHandler = useAxiosErrorHandler();
  const isMounted = useIsMounted();
  const [data, setData] = React.useState<Slide[]>([]);
  const [loading, setLoading] = React.useState(true);

  const makeRequest = React.useCallback(async () => {
    setLoading(true);
    try {
      const response = await GetSlides(id, axiosRequestConfig);
      console.log('GetSlides', response);
      setData(response.data.slides.map((item) => generateSlide(item)));
    } catch (e) {
      axiosErrorHandler(e);
    } finally {
      if (isMounted) {
        setLoading(false);
      }
    }
  }, [axiosErrorHandler, axiosRequestConfig, id, isMounted]);

  React.useEffect(() => {
    makeRequest().catch(console.log);
  }, [makeRequest]);

  return React.useMemo(() => ({ data, loading }), [data, loading]);
};

export default useSlides;
